import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  GoogleAdGroupsWithInsights,
  GoogleAdGroupsWithInsightsVariables
} from './__generated__/GoogleAdGroupsWithInsights';

const AD_GROUPS_WITH_INSIGHTS_QUERY = gql`
  query GoogleAdGroupsWithInsights($filter: AdGroupsFilterInput!, $dateRange: DateRangeInput!) {
    googleAdGroups(filter: $filter) {
      id
      resourceName
      activeAdsCount
      status
      googleCampaign {
        id
        resourceName
        primaryStatusReasons
        googleCampaignBudget {
          dailyBudget
        }
        article {
          id
          campaignId
          title
          url
          articleGroup {
            id
          }
        }
      }
      googleInsights(dateRange: $dateRange) {
        clicks
        impressions
        cost
        cpc
        cpm
        ctr
      }
    }
  }
`;

export const useAdGroupsWithInsightsQuery = () => {
  return useLazyQuery<GoogleAdGroupsWithInsights, GoogleAdGroupsWithInsightsVariables>(AD_GROUPS_WITH_INSIGHTS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
